import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/noto-sans-jp';
import '@fontsource-variable/noto-serif-jp';

import { App } from './App';
import './styles.css';

const root = document.getElementById('root');

if (!root) throw new Error('Root element was not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
